import React from 'react'

export function ImageMetadata({ item }) {
  if (!item) return null

  const formatDepth = (depth) => {
    if (!depth) return 'N/A'
    return `${Math.abs(parseFloat(depth))}m`
  }

  const formatDate = (date) => {
    if (!date) return 'N/A'
    return new Date(date).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    })
  }

  const formatTime = (time) => {
    if (!time) return 'N/A'
    return time
  }

  return (
    <div className="image-metadata">
      {item.organisms && item.organisms.length > 0 && (
        <div className="metadata-item">
          <span className="-bold">Organisms:</span>
          <span>{item.organisms.join(', ')}</span>
        </div>
      )}
      {item.cephalopod_behavior && item.cephalopod_behavior.length > 0 && (
        <div className="metadata-item">
          <span className="-bold">Behavior:</span>
          <span>{item.cephalopod_behavior.join(', ')}</span>
        </div>
      )}
      <div className="metadata-item">
        <span className="-bold">Site:</span>
        <span>{item.site_name || 'N/A'}</span>
      </div>
      <div className="metadata-item">
        <span className="-bold">Date:</span>
        <span>{formatDate(item.date)}</span>
      </div>
      <div className="metadata-item">
        <span className="-bold">Time:</span>
        <span>{formatTime(item.time)}</span>
      </div>
      <div className="metadata-item">
        <span className="-bold">Depth:</span>
        <span>{formatDepth(item.depth)}</span>
      </div>
      {item.site_type && (
        <div className="metadata-item">
          <span className="-bold">Site Type:</span>
          <span>{item.site_type}</span>
        </div>
      )}
      <div className="metadata-item">
        <span className="-bold">Flash:</span>
        <span>{item.flash ? 'Yes' : 'No'}</span>
      </div>
    </div>
  )
}

